import {getUrlSearch} from "./get-url-search";
import {isEmptyArray} from "./is-empty-array";

export const getCurrentFilter = (filterList) => {
  const currentFilter = {};

  const filterUrl = getUrlSearch(`f`);

  if (!filterUrl) {
    return currentFilter;
  }

  const filters = filterUrl.split(`,`);

  Object.values(filterList).forEach((filterItem) => {
    const alias = filterItem.alias;
    const values = filterItem.values;

    const result = filters
      .filter((param) => param.slice(0, param.indexOf(`_`)) === alias)
      .map((param) => {
        const id = param.slice(param.indexOf(`_`) + 1);
        const valueId = Object.keys(values).find((key) => {
          return String(values[key].value) === id;
        });

        return {
          id,
          title: valueId ? values[valueId].title : ``,
        };
      });

    if (!isEmptyArray(result)) {
      if (filterItem.type === `rng`) {
        const minMaxResult = result.find((it) => it.id.indexOf(`-`) >= 0);
        const valuesResult = result
          .filter((it) => it.id.indexOf(`-`) < 0)
          .map((it) => {
            it.title = values[it.id];
            return it;
          });

        currentFilter[alias] = {
          type: `range`,
          title: filterItem.title,
          min: minMaxResult ? minMaxResult.id.split(`-`)[0] : ``,
          max: minMaxResult ? minMaxResult.id.split(`-`)[1] : ``,
          values: valuesResult,
        };
      }

      if (filterItem.type === `lst`) {
        currentFilter[alias] = {
          type: `list`,
          values: result,
        };
      }
    }
  });

  // добавление значения группы в filter
  filters
    .filter((param) => param.slice(0, param.indexOf(`_`)) === `group`)
    .forEach((param) => {
      const id = param.slice(param.indexOf(`_`) + 1);
      const newValue = {id, title: ``};
      currentFilter[`group`] = {
        type: `list`,
        values: [newValue]
      };
    });

  return currentFilter;
};
